<template>
    <div>
        <a-row>
            <!-- <a-col :span="1"/> -->
            <a-col :span="2">
                机构名称:
            </a-col>
            <a-col :span="4">
                <a-input v-model.trim="form.Name"/>
            </a-col>
            <!-- <a-col :span="1"/> -->
            <a-col :span="2">
                医废类别:
            </a-col>
            <a-col :span="4">
                <a-select v-model="form.Type" style="width: 195px" >
                    <a-select-option value="">
                      所有
                    </a-select-option>
                    <a-select-option value="1">
                      感染类
                    </a-select-option>
                    <a-select-option value="2">
                      损伤类
                    </a-select-option>
                    <a-select-option value="3">
                      病理类
                    </a-select-option>
                    <a-select-option value="4">
                      特殊类
                    </a-select-option>
                </a-select>
            </a-col>
            <!-- <a-col :span="1"/> -->
            <a-col :span="2">
                排序: 
            </a-col>
            <a-col :span="4">
                 <a-select v-model="form.OrderType" style="width: 195px" >
                    <a-select-option value="0">
                      按统计日期排序
                    </a-select-option>
                    <a-select-option value="1">
                      按重量排序
                    </a-select-option>
                </a-select>
            </a-col>
        </a-row>
        <a-row>
            <!-- <a-col :span="1"/> -->
            <a-col :span="2">
                按年/月统计
            </a-col>
            <a-col :span="4">
                <a-select v-model="form.CntType" style="width: 195px" @change="clear">
                  <a-select-option value="1">
                    按年统计
                  </a-select-option>
                  <a-select-option value="2">
                    按月统计
                  </a-select-option>
                 <a-select-option value="3">
                    按日统计
                  </a-select-option>
                </a-select>
            </a-col>
            <!-- <a-col :span="1"/> -->
            <a-col :span="2">
                开始时间：
            </a-col>
            <a-col :span="4">
                <a-date-picker @change="onChangeBengin" v-model="form.BeginDate" v-if="form.CntType==3"/>
                <a-select  v-model="form.BeginDate" style="width: 195px" allowClear v-if="form.CntType==2">
                  <a-select-option :value="item" v-for="(item,i) of sreachTime" :key="i">
                    {{item}}
                  </a-select-option>
                </a-select>
                <a-select  v-model="form.BeginDate" style="width: 195px" allowClear v-if="form.CntType==1">
                  <a-select-option :value="item" v-for="(item,i) of sreachYear" :key="i">
                    {{item}}
                  </a-select-option>
                </a-select>
            </a-col>
            <!-- <a-col :span="1"/> -->
            <a-col :span="2">
                结束时间：
            </a-col>
            <a-col :span="4">
                <a-date-picker @change="onChangeEnd" v-model="form.EndDate" v-if="form.CntType==3"/>
                <a-select  v-model="form.EndDate" style="width: 195px" allowClear v-if="form.CntType==2">
                  <a-select-option :value="item" v-for="(item,i) of sreachTime" :key="i">
                    {{item}}
                  </a-select-option>
                </a-select>
                <a-select  v-model="form.EndDate" style="width: 195px" allowClear v-if="form.CntType==1">
                  <a-select-option :value="item" v-for="(item,i) of sreachYear" :key="i">
                    {{item}}
                  </a-select-option>
                </a-select>
            </a-col>
            <a-col :span="4">
                <a-button type="primary" @click="look">
                    查询
                </a-button>
                <a-button type="primary" @click="Export" style="margin:0 10px">
                    导出
                </a-button>
            </a-col>
        </a-row>
        <a-table :columns="columns" :data-source="data" bordered :scroll="{y:'65vh'}" :pagination="false" rowKey="id"/>
    </div>
</template>

<script>
// ExportData
import {ReportCount,ExportData} from './js/ApiQuery'
const columns = [
    {
        title: '机构名称',
        dataIndex: 'name',
        key: 'name',
        ellipsis: true,
    },
    {
        title: '医废类别',
        dataIndex: 'type',
        key: 'type',
        ellipsis: true,
    },
    {
        title: '统计日期',
        dataIndex: 'dateMouth',
        key: 'dateMouth',
        ellipsis: true,
    },
    {
        title: '重量(公斤)',
        dataIndex: 'weight',
        key: 'weight',
        ellipsis: true,
    },
];
export default {
    data(){
        return{
            columns,
            data:[],
            form:{
                Type:'',
                Name:'',
                CntType:'1',
                BeginDate:'',
                EndDate:'',
                OrderType:'0',
                DataType:1
            },
            monthFormat: 'YYYY/MM',
            sreachTime:[],
            sreachYear:[]
        }
    },
    mounted(){
        this.getSreachTime()
        this.look()
    },
    methods:{
                // 选择开始时间
        onChangeBengin(date, dateString){
            this.form.BeginDate = dateString
        },
        // 选择结束时间
        onChangeEnd(date, dateString){
            this.form.EndDate = dateString
        },
        Export(){
            ExportData(this.form).then(res=>{
                var url = 'http://49.4.66.163:8000/api/FileUpload/file?url=' + res.data
                window.open(url, '_blank')
            })
        },
        look(){
            ReportCount(this.form).then(res => {
                this.data = res.data
            })
        },
        // 清空选择的开始结束时间
        clear(){
            if (this.form.CntType==1) {
                this.form.BeginDate = this.sreachYear[1]
                this.form.EndDate = this.sreachYear[0]
            }else if (this.form.CntType==2) {
                this.form.BeginDate = this.sreachTime[1]
                this.form.EndDate = this.sreachTime[0]
            }else if (this.form.CntType==3) {
                var date = new Date()
                this.form.BeginDate = date.getFullYear() + '-' + this.getZero(date.getMonth()) + '-'  + this.getZero(date.getDate())
                this.form.EndDate = date.getFullYear() + '-' + this.getZero((date.getMonth() + 1)) + '-'  + this.getZero(date.getDate())
            }
        },
        getZero(num) {    // 个位数前补0
          if (parseInt(num) < 10) {
              num = '0' + num;
          }
          return num;
        },
        getSreachTime(){
            var MonthList = ['12','11','10','09','08','07','06','05','04','03','02','01']
            var Year = new Date().getFullYear()
            var Month = new Date().getMonth() +1
            var YearList = []
            var NowMonthList = []
            var NowYearMonthList = []
            var NowSreachTime = []
            // 生成按月统计的时间list
            //获取当前年、月，生成本年的月份list
            for (let index = Month; index > 0; index--) {
                NowMonthList.push(index)
            }
            NowMonthList.forEach(item=>{
                if (item<10) {
                    item = '0' + item
                }
                var str = Year + '-' +item
                NowYearMonthList.push(str)
            })
            for (let index = (Year-1); index > (Year-4); index--) {
                YearList.push(index)       
            }
            // YearList = NowYearMonthList.concat(YearList)
            // 获取按年统计的时间list
            for (let index = Year; index > (Year-10); index--) {
                index = index.toString()
               this.sreachYear.push(index)       
            }
            YearList.forEach(item=>{
                MonthList.forEach(element=>{
                    var str = item + '-' +element
                    NowSreachTime.push(str)
                })
            })
            this.sreachTime = NowYearMonthList.concat(NowSreachTime)
            this.clear()
        }
    }
}
</script>

<style>

</style>